<div class="admin-user-management-asa-search-dialog" [class.close]="shouldClose">
  <header class="section" style="margin-bottom: 20px;">
    <h1>{{ 'userSearch.title' | translate }}</h1>
  </header>
  <div>&nbsp;</div>
  <section>
    <h3>{{'userSearch.searchParameters' | translate}}</h3>
    <p class="help-text">
      {{'userSearch.helpText' | translate}}<br />
    </p>
    <div class="generatedHTMLRoot">
      <div class="mainSection">
        <div class="section" style="width: 100%">
          <div class="sectionRowContainer">
            <div class="sectionRow">
              <div class="sectionFieldContainer">
                <div class="field width50percent">
                  <div class="labelContainer">
                    <span class="dialogLabel uppercase">{{ 'userSearch.filterInput' | translate }}</span>
                  </div>
                  <div class="fieldContainer">
                    <input kendoTextBox type="text"
                           [(ngModel)]="filterInput"
                           (ngModelChange)="onFilterInputChanged($event)" />
                  </div>
                </div>
                <div class="field width50percent">
                  <div class="labelContainer">
                    <span class="dialogLabel uppercase">{{ 'userSearch.filterBy' | translate }}</span>
                  </div>
                  <div class="fieldContainer">
                    <kendo-dropdownlist [data]="filterByOptions"
                                        textField="description"
                                        valueField="oid"
                                        [valuePrimitive]="true"
                                        [(ngModel)]="filterBy"
                                        (ngModelChange)="onFilterByChanged($event)"></kendo-dropdownlist>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lower-area">
      <loading-indicator [show]="isLoading"></loading-indicator>
      <ng-container *ngIf="searchResults">
        <h3>{{'userSearch.searchResults' | translate}}</h3>
        <div class="grid-host">
          <kendo-grid class="retriever-grid"
                      [kendoGridBinding]="searchResults"
                      [pageable]="{
                        buttonCount: 2,
                        pageSizes: false,
                        previousNext: true
                      }"
                      [pageSize]="10">
            <kendo-grid-column field="User_Lastname" [width]="138" [title]="'userSearch.lastName' | translate"></kendo-grid-column>
            <kendo-grid-column field="User_Firstname" [width]="138" [title]="'userSearch.firstName' | translate"></kendo-grid-column>
            <kendo-grid-column field="User_Description" [width]="138" [title]="'userSearch.description' | translate"></kendo-grid-column>
            <kendo-grid-column field="User_Email" [width]="138" [title]="'userSearch.upn' | translate"></kendo-grid-column>
            <kendo-grid-column field="User_Email" [width]="138" [title]="'userSearch.createUser' | translate">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <button class="action-button" kendoButton (click)="createUser(dataItem)">{{'userSearch.createUser' | translate}}</button>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </ng-container>
    </div>
    <div class="footer-content">
      <button kendoButton class="action-button" (click)="createUserManually()">{{ 'userSearch.createUserManually' | translate }}</button>
      <button kendoButton class="action-button" (click)="close()">{{ 'userSearch.cancel' | translate }}</button>
    </div>
  </section>
</div>
